import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "confirmation-text" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }

import { ref, computed } from 'vue';
import { useMutation } from '@vue/apollo-composable';
import { ProjectDeleteDocument } from '@/gql/graphql';
import {
  BAlert,
  BBadge,
  BButton,
  BFormInput,
  BModal,
  BSpinner,
} from 'bootstrap-vue-next';

// --- Component properties ---

export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectDelete',
  props: {
    show: { type: Boolean },
    projectName: {},
    projectId: {}
  },
  emits: ['close', 'closeAndRefresh'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// --- Component emits ---
const emits = __emit;

// --- Component state ---
const show = computed<boolean>(() => {
  return props.show;
});
const projectNameConfirmation = ref<string>('');

// --- Mutation: Rename Data Object ---
const mutationInProgress = ref<boolean>(false);
const mutationError = ref<string | null>(null);
const mutationShowSuccess = ref<boolean>(false);

const {
  mutate: executeMutation,
  onDone: onMutationDone,
  onError: onMutationError,
} = useMutation(ProjectDeleteDocument);

onMutationDone((res) => {
  mutationInProgress.value = false;
  if (res.data && res.data.projectDelete) {
    console.debug('Project deleted:', res.data.projectDelete);
    mutationShowSuccess.value = true;
    setTimeout(() => {
      mutationShowSuccess.value = false;
      emits('closeAndRefresh');
    }, 1000);
  } else {
    mutationError.value = 'Project deletion failed: ' + res.data;
    console.error('Project deletion failed:', res.data);
  }
});

onMutationError((err) => {
  console.error('Error deleting project:', err);
  mutationInProgress.value = false;
  mutationError.value = err.message;
});

// --- Handle component actions ---
function onDeletionConfirmed() {
  mutationInProgress.value = true;
  mutationError.value = null;
  executeMutation({ id: props.projectId });
}

function handleCloseModal() {
  emits('close');
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(BModal), {
      modelValue: show.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((show).value = $event)),
      onHide: handleCloseModal
    }, {
      title: _withCtx(() => [
        _createVNode(_component_font_awesome_icon, {
          icon: "trash",
          class: "me-2"
        }),
        _cache[4] || (_cache[4] = _createTextVNode(" Delete project ", -1))
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(BButton), {
          variant: "secondary",
          onClick: handleCloseModal
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createTextVNode(" Cancel ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_unref(BButton), {
          variant: "danger",
          disabled: 
            mutationInProgress.value ||
            mutationShowSuccess.value ||
            projectNameConfirmation.value !== props.projectName
          ,
          onClick: onDeletionConfirmed
        }, {
          default: _withCtx(() => [
            (mutationInProgress.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                  _cache[11] || (_cache[11] = _createTextVNode(" Deleting Project ", -1)),
                  _createVNode(_unref(BSpinner), {
                    small: "",
                    label: ""
                  })
                ]))
              : (mutationShowSuccess.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                    _cache[12] || (_cache[12] = _createTextVNode(" Project Deleted ", -1)),
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fa', 'check-double'],
                      class: "me-2"
                    })
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, " Delete Project "))
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("h5", null, "Delete " + _toDisplayString(props.projectName) + "?", 1),
          _createVNode(_unref(BBadge), {
            variant: "danger",
            class: "mb-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: "exclamation-triangle" }),
              _cache[5] || (_cache[5] = _createTextVNode(" This action is irreversible ", -1))
            ]),
            _: 1
          }),
          _cache[8] || (_cache[8] = _createElementVNode("p", null, [
            _createElementVNode("strong", null, " All associated data will be permanently deleted. ")
          ], -1)),
          _cache[9] || (_cache[9] = _createElementVNode("p", null, " If you wish to proceed with deletion, please type in the name of the project and click the button bellow. ", -1)),
          _createElementVNode("p", null, [
            _createElementVNode("strong", null, [
              _cache[6] || (_cache[6] = _createTextVNode("Type ", -1)),
              _createElementVNode("span", _hoisted_1, _toDisplayString(props.projectName), 1),
              _cache[7] || (_cache[7] = _createTextVNode(" for confirmation:", -1))
            ])
          ]),
          _createVNode(_unref(BFormInput), {
            modelValue: projectNameConfirmation.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((projectNameConfirmation).value = $event)),
            type: "text",
            placeholder: "Type the name of the project to confirm deletion",
            disabled: mutationInProgress.value || mutationShowSuccess.value,
            class: "mb-3"
          }, null, 8, ["modelValue", "disabled"]),
          _createVNode(_unref(BAlert), {
            modelValue: mutationError.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((mutationError).value = $event)),
            variant: "danger",
            dismissible: "",
            class: "mt-3",
            onDismissed: _cache[2] || (_cache[2] = ($event: any) => (mutationError.value = null))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(mutationError.value), 1)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})